// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./StorageSharedKeyCredentialPolicyV2-browser.mjs";
